module.exports = __webpack_public_path__ + "static/audioteka-833845120e1e9c00d93b3200e44800c6.png";